import { createContext } from "react";

const NavigationContext = createContext(null);

export { NavigationContext };
